<template lang="pug">
div
  app-pdf-viewer(:bytes="bytes" v-if="bytes")
  div.buttonPosition
    el-button(type="primary", @click="exportarPdf")
      i.fal.fa-file-pdf
      span &nbsp Exportar PDF
  app-divider(label="Forma de pagamento", :showBorder="true", :required="true")
  .container-input
    validation-provider(rules="required", v-slot="{ errors }", name="Fator Acesso")
      el-radio-group.checkbox-group.input(v-model="formaPagamento" :class="{'erro' : errors.length}")
        el-radio(label="PARCELADO") Pagamento parcelado
        el-radio(label="A_VISTA") Pagamento à vista com desconto
      span.help.erro {{ errors[0] }}

  .container-input(v-if="formaPagamento === 'PARCELADO'")
      el-row(:gutter="10")
        el-col(:span="8").container-input
          validation-provider(rules="required", v-slot="{ errors }", name="Fator distância")
            app-label(label="Quantidade de parcelas:", :required="true")
            el-select.input(
              class="select",
              placeholder="Selecione",
              value-key="id",
              name="Fator distância",
              :class="{'erro' : errors.length}"
              v-model="quantidadeParcelas"
              clearable
            )
              el-option(
                v-for="item in parcelas",
                :key="item",
                :label="item",
                :value="item"
              )
            span.help.erro {{ errors[0] }}

        el-col(:span="16").container-input
          validation-provider(rules="required|min_value:10|max_value:99.99", v-slot="{ errors }", name="Entrada")
            app-label(label="Entrada (%):", :required="true")
            app-double-input(v-model="valorEntrada", :hasValidationError="errors[0] ? true : false")
            span.help.erro {{ errors[0] }}
</template>

<script>
import AppDivider from '@/components/AppDivider'
import AppLabel from '@/components/AppLabel'
import AppDoubleInput from '@/components/AppDoubleInput'
import AppPDFViewer from '@/components/AppPDFViewer'

export default {
  components: {
    AppDivider,
    AppLabel,
    AppDoubleInput,
    AppPdfViewer: AppPDFViewer
  },

  async created () {
    this.bytes = await this.$store.dispatch('vtn/exportarPdfToView', this.$route.params.numeroProcesso)
  },

  data () {
    return {
      parcelas: [2, 3, 4, 5, 6, 7, 8, 9, 10],
      settings: {
        maxScrollbarLength: 60
      },
      bytes: null
    }
  },

  methods: {
    exportarPdf () {
      this.$store.dispatch('vtn/exportarPdfToDownload')
    }
  },

  computed: {
    formaPagamento: {
      get () {
        return this.$store.state.vtn.dadosVtn.formaPagamento
      },
      set (value) {
        this.$store.commit('vtn/SET_FIELD_VALUE', { field: 'formaPagamento', value })
      }
    },
    quantidadeParcelas: {
      get () {
        return this.$store.state.vtn.dadosVtn.quantidadeParcelas
      },
      set (value) {
        this.$store.commit('vtn/SET_FIELD_VALUE', { field: 'quantidadeParcelas', value })
      }
    },
    valorEntrada: {
      get () {
        return this.$store.state.vtn.dadosVtn.valorEntrada
      },
      set (value) {
        this.$store.commit('vtn/SET_FIELD_VALUE', { field: 'valorEntrada', value })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.checkbox-group {
  display: flex;
  justify-content: space-evenly;
  padding: 5px;
}
#pdf {
  text-align: center;
  margin: 1%;
  border-radius: 15px;
  height: 500px;
  margin-top: 1cm;
  border:1px solid #eaeef1;
}
.buttonPosition {
  margin-top: 15px;
  display: flex;
  justify-content: center;
}
.scroll-area {
  position: relative;
  margin: auto;
  height: 500px;
  background-color: transparent;
  border-radius: 15px;
  border:1px solid #eaeef1;
}
</style>



// WEBPACK FOOTER //
// src/screens/financeiro/vtn/FormaPagamento.vue